import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    saveToStorage,
    clearStorage,
    getFromStorage,
} from '@forvalter/utils/storage';
import { localStorageReferences } from '../config';

enum prosjektSelectorActionsReferences {
    SAVE_PROSJEKT_STATUS = 'prosjekt/saveselectedProsjektStatusToStorage',
    CLEAR_PROSJEKT_STATUS = 'prosjekt/clearSelectedProsjektStatusFromStorage',
}

export type IProsjektState = {
    activeModalProsessInstansId?: string;
    openModal: boolean;
    selectedProsjektStatus: Array<string>;
    showSelectedProsjektSummary?: boolean;
    prosjektTableFilters?: Array<Array<string>>;
};

export interface IProsjektStore {
    prosjekt: ReturnType<typeof prosjektSlice.reducer>;
    openModal: boolean;
}

const saveSelectedProsjektStatusToStorage = createAsyncThunk(
    prosjektSelectorActionsReferences.SAVE_PROSJEKT_STATUS,
    async (status: Array<string>) => {
        if (status) {
            saveToStorage(
                localStorageReferences.SELECTED_PROSJEKT_STATUS,
                status,
            );
            return status;
        }
        throw new Error('No prosjekt received');
    },
);

const clearSelectedProsjektStatusFromStorage = createAsyncThunk(
    prosjektSelectorActionsReferences.CLEAR_PROSJEKT_STATUS,
    async () => {
        clearStorage(localStorageReferences.SELECTED_PROSJEKT_STATUS);
        return null;
    },
);

const selectedProsjektStatusFromStorage =
    (getFromStorage(localStorageReferences.SELECTED_PROSJEKT_STATUS) as
        | Array<string>
        | undefined) ?? [];

const initialState: IProsjektState = {
    showSelectedProsjektSummary: undefined,
    selectedProsjektStatus: selectedProsjektStatusFromStorage,
    activeModalProsessInstansId: undefined,
    openModal: false,
};

const prosjektSlice = createSlice({
    name: 'prosjekt',
    initialState,
    reducers: {
        setActiveModalProsessInstansId: (state, action) => {
            state.activeModalProsessInstansId = action.payload;
        },
        setOpenModal: (state, action) => {
            state.openModal = action.payload;
        },
        setShowSelectedProsjektSummary: (state, action) => {
            state.showSelectedProsjektSummary = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                saveSelectedProsjektStatusToStorage.fulfilled,
                (state, action) => {
                    return {
                        ...state,
                        selectedProsjektStatus: action.payload,
                    };
                },
            )
            .addCase(
                clearSelectedProsjektStatusFromStorage.fulfilled,
                (state) => {
                    return {
                        ...state,
                        selectedProsjektStatus: [],
                    };
                },
            );
    },
});

export const prosjektActions = {
    ...prosjektSlice.actions,
    saveSelectedProsjektStatusToStorage,
    clearSelectedProsjektStatusFromStorage,
    reducerActions: prosjektSlice.actions,
};

export const prosjektSelectors = ({ prosjekt }: IProsjektStore) => prosjekt;

export default prosjektSlice;
